<template>
  <el-col :span="24" :style="{height: height}">
    <div :class="className" :style="{height:chartHeight,width:chartWidth}" />
  </el-col>
</template>

<script>
  import echarts from 'echarts'
  require('echarts/theme/macarons') // echarts theme
  import {
    debounce
  } from '../utils/helper.js'
  import lodash from 'lodash'
  var colorList = ['rgba(2,175,255,1)', 'rgba(0,75,228,1)', 'rgba(72,149,245,1)', 'rgba(0,228,255,1)',
    'rgba(0,145,228,1)', '#FE8463'
  ];
  export default {
    props: {
      className: {
        type: String,
        default: 'chart'
      },
      width: {
        type: Number,
        default: 24
      },
      height: {
        type: String,
        default: '100%'
      },
       show:{
              type:Boolean,
              default:true
            },
      // 图标配置
      chartConfig: {
        type: Object,
        default: null
      }

    },
    data() {
      return {
        chart: null,
        chartConfigModel: {},
        chartWidth: '100%',
         chartHeight:'100%',
        defaultConfig: {
          title: {
            text: '',
            subtext: '',
            left: 'center'
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            type: 'scroll',
            orient: 'vertical',
            textStyle: {
              color: '#189ECD',
              fontWeight: 'bold'
            },
            right: 'auto',
            top: 'auto',
            bottom: 'auto',
            left: 'auto',
            // formatter: function(name) {
            //   let index = 0;
            //   let clientlabels = this.chartConfig.legend.data;
            //   let clientcounts = this.chartConfig.series[0].data;
            //   clientlabels.forEach(function(value, i) {
            //     if (value == name) {
            //       index = i;
            //     }
            //   });
            //   return name + "  " + clientcounts[index].value;
            // },
            data: []
          },
          calculable: true,
          color: colorList,
          series:  [{
							type: 'pie',
							radius: '75%',
							center: ['50%', '50%'],
							data: [],
							animationEasing: 'cubicInOut',
							animationDuration: 2600,
							label: {
								show: true,
								position: 'outside',
								formatter: '{a} {b} : {c} ({d}%)'
							}
						}]
        }
      }
    },
    watch: {
      // 防止表格预置数据不成功，涉及生命周期问题
      chartConfig: {
        handler(newValue, oldValue) {
          this.chartConfigModel = lodash.cloneDeep(newValue)
         let _config=lodash.cloneDeep(this.defaultConfig)
         lodash.merge(_config,this.chartConfigModel)
         this.chartConfigModel=_config
          this.setOptions(false)
        },
        deep: true
      },
      height: {
        handler(newValue, oldValue) {
          this.__resizeHandler()
        },
        deep: true
      },
      width: {
        handler(newValue, oldValue) {
          this.__resizeHandler()
        },
        deep: true
      },
      show:{
        handler(newValue,oldValue){
          this.__resizeHandler()
        },
        deep:true
      }
    },
    mounted() {
      this.chartConfigModel = lodash.cloneDeep(this.chartConfig)
      let _config=lodash.cloneDeep(this.defaultConfig)
      lodash.merge(_config,this.chartConfigModel)
      this.chartConfigModel=_config
      this.initChart()

      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      window.removeEventListener('resize', this.__resizeHandler)
      this.chart.dispose()
      this.chart = null
    },
    methods: {
      setOptions(notMerge) {
        this.chart.setOption(this.chartConfigModel, notMerge)
        this.chart.resize()
      },
      initChart() {
        this.chart = echarts.init(this.$el, 'macarons')
        this.setOptions(false)
        this.chart.on('finished', function() {
          try {
            var _charts = document.getElementsByTagName('canvas')
            for (var i = 0; i < _charts.length; i++) {
              _charts[i].style.cursor = 'default'
            }
          } catch (e) {

          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PieChart.vue